import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';

export type Theme = 'light' | 'dark';

interface ThemeState {
  mode: Theme;
}

const STORAGE_KEY = 'dybr-theme';

function loadThemeFromStorage(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    // ignore
  }
  return 'light';
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: (): ThemeState => ({ mode: loadThemeFromStorage() }),
  reducers: {
    setTheme(state, action: PayloadAction<Theme>) {
      state.mode = action.payload;
      try {
        localStorage.setItem(STORAGE_KEY, action.payload);
      } catch {
        // ignore
      }
    },
    toggleTheme(state) {
      const next: Theme = state.mode === 'light' ? 'dark' : 'light';
      state.mode = next;
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // ignore
      }
    }
  }
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
export const selectThemeMode = (state: RootState) => state.theme.mode;
